// extracted by mini-css-extract-plugin
export default {"container":"NoGadgetFound_container__8Pe7M"};